import styled from "styled-components";

export const StyledSwitch = styled.div`
  .toggle-switch {
    position: relative;
    width: 55px;
    display: inline-block;
    text-align: left;
  }
  .checkbox {
    display: none;
  }
  .label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 0 solid #bbb;
    border-radius: 20px;
  }
  .inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
  }
  .inner:before,
  .inner:after {
    float: left;
    width: 50%;
    height: 28px;
    padding: 0;
    line-height: 28px;
    color: #fff;
    font-weight: bold;
    box-sizing: border-box;
    font-size: 10px;
  }
  .inner:before {
    content: "YES";
    padding-left: 7px;
    background-color: #6e0072;
    color: #fff;
  }
  .inner:after {
    content: "NO";
    padding-right: 10px;
    background-color: #bbb;
    color: #fff;
    text-align: right;
  }
  .switch {
    display: block;
    width: 18px;
    margin: 5px;
    background: #fff;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 28px;
    border: 0 solid #bbb;
    border-radius: 50%;
    transition: all 0.3s ease-in 0s;
  }
  .checkbox:checked + .label .inner {
    margin-left: 0;
  }
  .checkbox:checked + .label .switch {
    right: 0px;
  }
`;
